exports.list = {
    path: '/koreksi_minus',
    name: 'koreksi_minus', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/koreksi_minus/List.vue"),
}
exports.show = {
    path: '/koreksi_minus/show/:no_transaksi',
    name: 'koreksi_minus_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/koreksi_minus/Show.vue"),
  }